<template>
  <div>
    <v-list>
      <v-subheader class="subtitle-2 primary--text">
        Schedule
      </v-subheader>
      <v-list-item style="height: 56px">
        <v-list-item-icon>
          <v-icon>mdi-calendar-today</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>
            Schedule: {{ getValueByKey('scheduleValue') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon>
          <v-icon>mdi-history</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>
           Last execution: {{ getLastExecutionDate() }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon>
          <v-icon :color="getStatus.color">
            {{ getStatus.icon }}
          </v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>
            Execution status: {{ getStatus.title }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item style="height: 56px">
        <v-btn
          v-if="getStatus.status === SCHEDULE_STATUSES.IN_PROGRESS"
          color="primary"
          block
          dense
          outlined
          disabled
        >
          Schedule is running
        </v-btn>
        <v-btn
          color="primary"
          v-else
          block
          data-test="runSchedule"
          dense
          :loading="callRpcHttpLoading"
          :disabled="callRpcHttpLoading"
          outlined
          @click="executeControl"
        >
          Run schedule
        </v-btn>
      </v-list-item>

      <!--      <v-subheader class="subtitle-2 primary&#45;&#45;text">-->
      <!--        Filters-->
      <!--      </v-subheader>-->

      <!--      <v-hover-->
      <!--        v-slot:default="{ hover }"-->
      <!--        v-for="filter in filters"-->
      <!--        :key="filter.id"-->
      <!--      >-->
      <!--        <v-list-item>-->
      <!--          <v-list-item-icon>-->
      <!--            <v-icon>mdi-tune</v-icon>-->
      <!--          </v-list-item-icon>-->

      <!--          <v-list-item-content>-->
      <!--            <v-list-item-title>-->
      <!--              {{ filter.name }}-->
      <!--            </v-list-item-title>-->
      <!--          </v-list-item-content>-->
      <!--          <v-list-item-action>-->
      <!--            <dropdown-menu-->
      <!--              item-key-text="text"-->
      <!--              itemKeyValue="id"-->
      <!--              :items="getFilterContextMenu(filter)"-->
      <!--              :hover="hover"-->
      <!--              @input="() => ({})"-->
      <!--            >-->
      <!--              <template v-slot:activator="{ on }">-->
      <!--                <slot name="activator" :on="on">-->
      <!--                  <v-btn-->
      <!--                    slot="activator"-->
      <!--                    v-show="hover || $vuetify.breakpoint.mdAndDown"-->
      <!--                    v-on="on"-->
      <!--                    class="table-button-context"-->
      <!--                    icon-->
      <!--                  >-->
      <!--                    <v-icon>mdi-dots-vertical</v-icon>-->
      <!--                  </v-btn>-->
      <!--                </slot>-->
      <!--              </template>-->
      <!--            </dropdown-menu>-->
      <!--          </v-list-item-action>-->
      <!--        </v-list-item>-->
      <!--      </v-hover>-->

      <!--      <v-list-item style="height: 56px" @click="addNewFilter">-->
      <!--        <v-list-item-icon>-->
      <!--          <v-icon>mdi-plus</v-icon>-->
      <!--        </v-list-item-icon>-->

      <!--        <v-list-item-content>-->
      <!--          <v-list-item-title>-->
      <!--            Add filter-->
      <!--          </v-list-item-title>-->
      <!--        </v-list-item-content>-->
      <!--      </v-list-item>-->

      <v-subheader class="subtitle-2 primary--text">
        Controls
      </v-subheader>

      <draggable
        v-bind="dragOptions"
        v-model="controlsList"
        @start="onDragStart"
        @end="onDragEnd"
      >
        <transition-group>
          <div v-for="control in controlsList" :key="control.id">
            <v-hover v-slot:default="{ hover }">
              <v-list-item style="height: 56px;" :title="control.name">
                <v-list-item-icon>
                  <v-icon v-if="control.execution.stopOnFailure">
                    mdi-lock-alert
                  </v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>
                    {{ control.name }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <dropdown-menu
                    item-key-text="text"
                    itemKeyValue="id"
                    :items="getControlContextMenu(control)"
                    :hover="hover"
                  >
                    <template v-slot:activator="{ on }">
                      <slot name="activator" :on="on">
                        <v-btn
                          :data-test-control-drag="control.name"
                          :title="dragOptions.disabled ? 'Saving order...' : ''"
                          :disabled="dragOptions.disabled"
                          :class="{ 'save-item': dragOptions.disabled }"
                          v-show="hover || $vuetify.breakpoint.mdAndDown"
                          icon
                        >
                          <v-icon>mdi-drag-horizontal-variant</v-icon>
                        </v-btn>
                        <v-btn
                          :data-test-control-ctx="control.name"
                          slot="activator"
                          v-show="hover || $vuetify.breakpoint.mdAndDown"
                          v-on="on"
                          icon
                        >
                          <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                      </slot>
                    </template>
                  </dropdown-menu>
                </v-list-item-action>
              </v-list-item>
            </v-hover>
          </div>
        </transition-group>
      </draggable>

      <v-list-item @click="addNewControl" data-test="addControl">
        <v-list-item-icon>
          <v-icon>mdi-plus</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>
            Add control
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <app-entity-tab-list :tab-data="tabData" />
  </div>
</template>

<script>
import DropdownMenu from '@/components/DropdownMenu';
import useCommonModal from '@/compositions/useCommonModal';
import { computed, reactive, ref, watch } from '@vue/composition-api';
import { useMutation } from '@vue/apollo-composable';
import gql from '@/api/objects/item.graphql';
import draggable from 'vuedraggable';
import { toReactive } from '@vueuse/core';
import { useThrottleFn } from '@vueuse/core';
import cloneDeep from 'lodash.clonedeep';
import AppEntityTabList from '@/components/app-entity/app-entity-tab/TabProperties.vue';
import convertDate from '@/utils/convertDate';
import { SCHEDULE_STATUSES } from '@/router/routes/schedules/constants';

export default {
  name: 'ScheduleGeneralTab',
  components: {
    AppEntityTabList,
    DropdownMenu,
    draggable
  },
  props: {
    entity: {
      type: Object,
      default: () => ({})
    },
    tabData: {
      type: Object,
      default: () => ({})
    },
    isNestedEntity: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const modalComposition = useCommonModal();
    const { mutate: updateProperty } = useMutation(gql.updateObjectProperty);
    const { mutate: createControlExecution } = useMutation(
      gql.createControlsExecution
    );
    const callRpcHttpLoading = ref(false);

    const localState = reactive({
      dragOptions: {
        animation: 200,
        disabled: false,
        ghostClass: 'ghost-control-item'
      },
      drag: false
    });

    const controlsList = ref([]);

    const handleClickItem = item => {
      if (!props.isNestedEntity && item.actionClickElement) {
        item.actionClickElement();
      }
    };

    const copyText = e => {
      context.root.$copyText(e).catch(err => {
        console.error(`Cannot copy: ${err}`);
      });
    };

    const addNewControl = (e, filterId) => {
      modalComposition.modal.show({
        component: () => import('@/components/app-entity/modals/AppDialog.vue'),
        bind: {
          nameModal: 'AddControlModal'
        },
        slots: {
          default: {
            component: () =>
              import(
                '@/components/app-entity/app-entity-tab/schedule/AddControlModal.vue'
              ),
            bind: {
              linkedObjects: props.entity.objectsToObjectsByObject1Id.map(
                item => ({
                  id: item.object2.id,
                  name: item.object2.name,
                  schema: item.object2.schema
                })
              ),
              entity: {
                id: filterId
              },
              targetProperty: getPropByKey('settingsControls')
            },
            on: {
              close() {
                modalComposition.modal.hide('AddControlModal');
              }
            }
          }
        }
      });
    };

    const addNewFilter = (e, controlId) => {
      modalComposition.modal.show({
        component: () => import('@/components/app-entity/modals/AppDialog.vue'),
        bind: {
          nameModal: 'AddFilterModal'
        },
        slots: {
          default: {
            component: () =>
              import(
                '@/components/app-entity/app-entity-tab/schedule/AddFilterModal.vue'
              ),
            bind: {
              entity: {
                id: controlId
              },
              targetProperty: getPropByKey('settingsFilters')
            },
            on: {
              close() {
                modalComposition.modal.hide('AddFilterModal');
              }
            }
          }
        }
      });
    };

    const getPropByKey = key => {
      return props.entity.objectProperties.find(item => item.key === key);
    };

    const filters = computed(() => {
      return getPropByKey('settingsFilters')?.value || [];
    });

    const controls = computed(() => {
      return getPropByKey('settingsControls')?.value || [];
    });

    const getValueByKey = key => {
      const prop = getPropByKey(key);

      if (prop) {
        return prop?.value || 'n/a';
      }

      return 'n/a';
    };

    const getLastExecutionDate = () => {
      const prop = getPropByKey('scheduleLastExecution');

      if (!prop.value) {
        return 'n/a';
      }

      return convertDate(prop.value);
    };

    const getStatus = computed(() => {
      const prop = getPropByKey('scheduleStatusExecution');

      const base = {
        title: prop?.value?.title || 'n/a',
        status: prop?.value?.id
      };

      switch (prop?.value?.id) {
        case SCHEDULE_STATUSES.IN_PROGRESS:
          return {
            ...base,
            color: 'primary',
            icon: 'mdi-circle-slice-5'
          };
        case SCHEDULE_STATUSES.BROKEN:
          return {
            ...base,
            color: '#D50000',
            icon: 'mdi-alert-circle-outline'
          };
        case SCHEDULE_STATUSES.PAUSED:
          return {
            ...base,
            color: '',
            icon: 'mdi-pause-circle-outline'
          };
        default:
          return {
            ...base,
            color: '',
            icon: 'mdi-check-circle-outline'
          };
      }
    });

    watch(
      () => controls.value,
      () => {
        controlsList.value = cloneDeep(controls.value);
      },
      {
        immediate: true
      }
    );

    const deletePropItem = (filterId, propKey) => {
      const prop = getPropByKey(propKey);

      updateProperty({
        input: {
          id: prop.id,
          patch: {
            value: prop.value.filter(item => item.id !== filterId)
          }
        }
      }).then(() => {});
    };

    const getFilterContextMenu = item => {
      return [
        {
          id: 'editFilter',
          text: 'Edit',
          _enabled: true,
          icon: 'mdi-pencil',
          handleAction: () => {
            addNewFilter(null, item.id);
          }
        },
        {
          id: 'deleteFilter',
          text: 'Delete',
          _enabled: true,
          icon: 'mdi-delete',
          handleAction: () => {
            deletePropItem(item.id, 'settingsFilters');
          }
        }
      ];
    };

    const getControlContextMenu = item => {
      return [
        {
          id: 'editControl',
          text: 'Edit',
          _enabled: true,
          icon: 'mdi-pencil',
          handleAction: () => {
            addNewControl(null, item.id);
          }
        },
        {
          id: 'deleteControl',
          text: 'Delete',
          _enabled: true,
          icon: 'mdi-delete',
          handleAction: () => {
            deletePropItem(item.id, 'settingsControls');
          }
        }
      ];
    };

    const saveOrder = () => {
      localState.dragOptions.disabled = true;
      updateProperty({
        input: {
          id: getPropByKey('settingsControls').id,
          patch: {
            value: controlsList.value
          }
        }
      })
        .catch(() => {
          controlsList.value = cloneDeep(controls.value);
        })
        .finally(() => {
          localState.dragOptions.disabled = false;
        });
    };

    const throttledSaveOrder = useThrottleFn(saveOrder, 500);

    const onDragStart = () => {
      localState.drag = true;
    };

    const onDragEnd = () => {
      localState.drag = false;

      throttledSaveOrder();
    };

    const executeControl = e => {
      callRpcHttpLoading.value = true;
      createControlExecution({
        input: {
          controlExecution: {
            // objectId: 'fda37a04-1030-45cd-918a-6936d9744146',
            // params:
            //   '{"NUMBER_OF_STEPS":"3","PAUSE_DURATION_BETWEEN_EACH_STEP":"1"}',
            // name: 'ProgressBar'

            objectId: props.entity.id,
            params: '{}',
            name: 'RunSchedule'
          }
        }
      })
        .then(() => {
          // entityComposition.handleClose();
          // object.loading.value = false;
          // return loadData(entity.value.id);
        })
        .finally(() => {
          callRpcHttpLoading.value = false;
        });
    };

    return {
      ...toReactive(localState),
      callRpcHttpLoading,
      executeControl,
      getFilterContextMenu,
      getControlContextMenu,
      getLastExecutionDate,
      getValueByKey,
      filters,
      controls,
      getPropByKey,
      copyText,
      handleClickItem,
      addNewFilter,
      addNewControl,
      controlsList,
      onDragStart,
      onDragEnd,
      getStatus,
      SCHEDULE_STATUSES
    };
  }
};
</script>

<style>
.ghost-control-item {
  opacity: 0.5;
}

.save-item {
  cursor: not-allowed !important;
}
</style>
